// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M3Zha","index":"styles_index__5NjAl"};